var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
import { Tag } from "../../Tag";
import { ToolTip } from "../../ToolTip";
import { ViewIcon } from "../../Icons/ViewIcon";
export var MultiSelectGroupTag = React.forwardRef(function (_a, ref) {
    var selectedItems = _a.selectedItems, requestRemove = _a.onRequestRemove;
    var _b = __read(React.useState(false), 2), showSelectedToolTip = _b[0], setShowSelectedToolTip = _b[1];
    var viewToolTipRef = React.useRef(null);
    var onRequestRemove = React.useCallback(function () {
        requestRemove();
    }, [requestRemove]);
    var showSelectedItems = React.useCallback(function () {
        setShowSelectedToolTip(true);
    }, []);
    var hideSelectedItems = React.useCallback(function () {
        setShowSelectedToolTip(false);
    }, []);
    return (React.createElement(Tag, { ref: ref, className: "bn-multiselect-group-tag", onRequestRemove: onRequestRemove },
        React.createElement("span", { className: "icon-tag-container", ref: viewToolTipRef },
            React.createElement(ViewIcon, { size: "small", iconColor: showSelectedToolTip ? "primaryAccent" : "textLight", className: "icon-tag", onMouseEnter: showSelectedItems, onMouseLeave: hideSelectedItems })),
        React.createElement(ToolTip, { isOpen: showSelectedToolTip, anchorEl: viewToolTipRef.current, placement: "bottom" }, selectedItems.map(function (item, index) { return (React.createElement("div", { key: index }, item.label)); })), "".concat(selectedItems.length, " selected")));
});
//# sourceMappingURL=MultiSelectGroupTag.js.map